import { BasicPassFragment } from 'drycut-graphql';

import { ActionButtons, Button, FormHelpText, Heading, Stack } from 'ui-components';
import PassPrice from './PassPrice';
import { ControlledNameField } from '../ControlledNameField';
import { ControlledPhoneField } from '../ControlledPhoneField';
import { FormProvider, useForm } from 'react-hook-form';
import { PassPayment } from 'controlled-components';

type Props = {
  pass: BasicPassFragment;
  manual?: boolean;
  storeSlug?: string;
};

type PassPurchaseValues = {
  name: string;
  phone: string;
};

export function PassPurchaseForm({ storeSlug, pass, manual = false }: Props): React.ReactElement {
  const { title, subtitle, price } = pass;
  const formMethods = useForm<PassPurchaseValues>({
    defaultValues: {
      name: '',
      phone: '',
    },
  });

  return (
    <FormProvider {...formMethods}>
      <Stack gap={5} className="items-center text-center h-full">
        <Stack>
          <Heading variant="h2">{title}</Heading>
          {subtitle && <Heading variant="h6">{subtitle}</Heading>}
        </Stack>

        <PassPrice pass={pass} className="my-5" />

        <Stack
          as="fieldset"
          gap={4}
          className="w-72"
          disabled={formMethods.formState.isValidating || formMethods.formState.isSubmitting}
        >
          <ControlledNameField required />

          <div>
            <ControlledPhoneField autoComplete={manual ? 'off' : 'phone-number'} required />
            <FormHelpText className="text-zinc-400 font-aribau">
              Wir schicken Dir Deinen Code an diese Nummer.
            </FormHelpText>
          </div>
        </Stack>

        <ActionButtons className="mt-4">
          <PassPayment
            formMethods={formMethods}
            amount={price}
            data={{
              manual,
              customerName: formMethods.watch('name'),
              phoneNumber: formMethods.watch('phone'),
              passGid: pass.id,
              storeSlug: storeSlug,
            }}
          />
          <Button as="a" href={manual ? `/${storeSlug}` : '/passes'} fill="outlined">
            Cancel
          </Button>
        </ActionButtons>
      </Stack>
    </FormProvider>
  );
}
